module.exports = __webpack_public_path__ + "static/media/no-tickets-found.6eb99ee4.svg";